export default __webpack_public_path__ + "assets/933bc7d52bafbbf20284f825f6a15860.jpg";